(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-atc-bar')) {
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.link = this.querySelector('.sticky-atc__button');
        if (!this.target || !this.link) return;

        this.onClick = this.onClick.bind(this);
        this.onSectionSelect = this.onSectionSelect.bind(this);
        this.onSectionDeselect = this.onSectionDeselect.bind(this);
        this.link.addEventListener('click', this.onClick);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => this.toggle(!entry.isIntersecting),
            { threshold: 0 }
          );
          this.observer.observe(this.target);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateHeight());
          this.resizeObserver.observe(this);
        }

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:select', this.onSectionSelect);
          document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.link?.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.body.classList.remove('sticky-atc-active');
      }

      toggle(show) {
        if (this.forced) show = true;
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('sticky-atc-active', show);

        if (show) {
          this.removeAttribute('inert');
          this.removeAttribute('aria-hidden');
        } else {
          this.setAttribute('inert', '');
          this.setAttribute('aria-hidden', 'true');
        }
      }

      updateHeight() {
        document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      }

      onClick(event) {
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

        // Move keyboard focus back to the product content
        if (!this.target.hasAttribute('tabindex')) this.target.setAttribute('tabindex', '-1');
        this.target.focus({ preventScroll: true });
      }

      // Keep the bar visible in the theme editor while its section is selected
      onSectionSelect(event) {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.forced = true;
        this.toggle(true);
      }

      onSectionDeselect(event) {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.forced = false;
        const rect = this.target.getBoundingClientRect();
        this.toggle(rect.bottom <= 0 || rect.top >= window.innerHeight);
      }
    }

    customElements.define('sticky-atc-bar', StickyAtcBar);
  }

  } catch(e) { console.error(e); }
})();
})();
